import { render } from "./AddEditStory.vue?vue&type=template&id=d825aeec&lang=pug"
import script from "./AddEditStory.vue?vue&type=script&lang=js"
export * from "./AddEditStory.vue?vue&type=script&lang=js"

import "./AddEditStory.vue?vue&type=style&index=0&id=d825aeec&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__